export default __webpack_public_path__ + "static/media/cardRectangle.32c36f5d.svg";